/* eslint-disable react-refresh/only-export-components -- small sonner wrapper, component + helper by design */
import { Toaster as SonnerToaster, toast } from "sonner";
import { useTheme } from "@mui/material/styles";

export type ToastVariant = "success" | "error" | "info" | "warning";

/** Mount once near the root of the app (see App.tsx). */
export function Toaster() {
  const theme = useTheme();
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      theme={theme.palette.mode === "dark" ? "dark" : "light"}
    />
  );
}

/** Fire-and-forget toast helper so pages don't need to import `sonner` directly. */
export function showToast(message: string, variant: ToastVariant = "info"): void {
  switch (variant) {
    case "success":
      toast.success(message);
      break;
    case "error":
      toast.error(message);
      break;
    case "warning":
      toast.warning(message);
      break;
    default:
      toast(message);
  }
}
